export default __webpack_public_path__ + "static/media/36I-114274_-20443_0.ebc941d9.jpg";